import { OFDPaymentMethod, OFDPaymentSubject } from '../../types.ts'

export const OFD_PAYMENT_METHODS: Array<{
  label: string
  value: OFDPaymentMethod
}> = [
  { label: 'Предоплата 100%', value: 'FULL_PREPAYMENT' },
  { label: 'Частичная предоплата', value: 'PART_PREPAYMENT' },
  { label: 'Аванс', value: 'ADVANCE' },
  { label: 'Полный расчет', value: 'FULL_PAYMENT' },
  { label: 'Частичный расчет и кредит', value: 'PART_PAYMENT_AND_CREDIT' },
  { label: 'Передача в кредит', value: 'CREDIT' },
  { label: 'Оплата кредита', value: 'LOAN_PAYMENT' },
]

export const OFD_PAYMENT_SUBJECTS: Array<{ label: string; value: OFDPaymentSubject }> = [
  { label: 'Товар', value: 'GOOD' },
  { label: 'Работа', value: 'JOB' },
  { label: 'Услуга', value: 'SERVICE' },
  { label: 'Предоставление РИД', value: 'RESULT_OF_INTELLECTUAL_ACTIVITY' },
  { label: 'Платеж', value: 'PAYMENT' },
  { label: 'Агентское вознаграждение', value: 'AGENTS_COMMISSION' },
  { label: 'Подакцизный товар', value: 'EXCISABLE_GOOD' },
  { label: 'Ставка азартной игры', value: 'BET' },
  { label: 'Выигрыш азартной игры', value: 'BET_WIN' },
  { label: 'Лотерейный билет', value: 'LOTTERY_TICKET' },
  { label: 'Выигрыш лотереи', value: 'LOTTERY_WIN' },
  { label: 'Выплата', value: 'COMPLEX_PAYMENT_TARGET' },
  { label: 'Имущественное право', value: 'PROPERTY_LAW' },
  { label: 'Внереализационный доход', value: 'NON_OPERATION_INCOME' },
  { label: 'Иные платежи и взносы', value: 'OTHER_PAYMENT' },
  { label: 'Торговый сбор', value: 'TRADE_FEE' },
  { label: 'Курортный сбор', value: 'RESORT_FEE' },
  { label: 'Залог', value: 'PLEDGE' },
  { label: 'Расход', value: 'CONSUMPTION' },
  { label: 'Взносы на ОПС', value: 'PENSION_INSURANCE' },
  { label: 'Взносы на ОПС ИП', value: 'PENSION_INSURANCE_ENTREPRENEUR' },
  { label: 'Взносы на ОМС', value: 'MEDICAL_INSURANCE' },
  { label: 'Взносы на ОМС ИП', value: 'MEDICAL_INSURANCE_ENTREPRENEUR' },
  { label: 'Взносы СоцСтрах', value: 'SOCIAL_INSURANCE' },
  { label: 'Платеж казино', value: 'CASINO_PAYMENT' },
  { label: 'Иной предмет расчета', value: 'ANOTHER_PAYMENT_TARGET' },
]
